import { defineStore } from 'pinia'

const useCompany = defineStore('Company', {
  persist: true,
  state: (): State => {
    return {
      company: null,
    }
  },
  actions: {
    setCompany(company: CompanyInfo | null) {
      this.company = company
        ? {
            id: company.id,
            code: company.code,
            name: company.name,
            companyId: company.companyId,
            client: company.client,
          }
        : null
    },
  },
  getters: {
    getCompany(): CompanyInfo | null {
      return this.company ? this.company : null
    },
  },
})

interface State {
  company: CompanyInfo | null
}

interface CompanyInfo {
  id: string
  companyId: string
  code?: string
  name: string
  client: {
    id: string
    code?: string
    name: string
  }
}

export default useCompany
